import Dropdown from "react-bootstrap/esm/Dropdown"
import { FC } from "react"
import { IPageAction } from "../../../base/models"
import { MUIIcon } from "../../../widgets"
import { Property } from '../../../base/types'
import { useGetProperties } from '../../../base/hooks'

interface IActionDropdownHyperLinkProps {
    action: IPageAction
}

export const ActionDropdownHyperLink: FC<IActionDropdownHyperLinkProps> = ({
    action
}) => {
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];

    if (!pageUrl)
        return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

    return (
        <Dropdown.Item
            target={target || undefined}
            href={pageUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </Dropdown.Item>
    )
}